import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquare, faSigma } from '@fortawesome/pro-regular-svg-icons';

library.add(faSquare);
library.add(faSigma);